import { render, staticRenderFns } from "./AvatarBubble.vue?vue&type=template&id=0a8a1f73&scoped=true&"
import script from "./AvatarBubble.vue?vue&type=script&lang=js&"
export * from "./AvatarBubble.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBubble.vue?vue&type=style&index=0&id=0a8a1f73&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a1f73",
  null
  
)

export default component.exports